<div class="container">
    <div fxLayout="row" fxFlexFill class="card" [ngClass]="classAux" >
        <div fxFlex class="text-box" fxLayout="column" fxFlexFill fxLayoutAlign="center center">
                <h1>403</h1>
                <h3>Proibido!</h3>
                <h3>Você não possui permissão para acessar este conteúdo.</h3>
                <h3>Para acessa-lo, entre em contato com o administrador do sistema.</h3>
        </div>
    </div>
</div>